import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';
import { isEmpty } from 'lodash';

const api = services.api;

// 面单打印管理
export const FindDeliveryPageLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        debugger;
        const newParams = {
            ...params,
        };
        if (!!params.update_time && !isEmpty(params.update_time)) {
            newParams.start = params.update_time.start;
            newParams.end = params.update_time.end;
            delete newParams.update_time;
        }
        if (newParams.printed === '__ALL__') {
            newParams.printed = '';
        }
        config.apiPath = `/shippingOrderNew/deliveryPage`;
        return api.post(newParams, config);
    },
};
